export class User {
    constructor(
        public username: String,
        public mobilenumber: String,
        public password: String,
        public isadmin: Boolean
    ){

    }
}